export const strings = {
    logo: 'K.I.C',
    navLinks: {
        1: 'About Fund',
        2: 'The collection',
        3: 'Team',
        4: 'FAQ',
    },
    navBtn: 'Share',
    heroTxt: `Kids in <br/>Conflict`,
    subTxt: 'ESCAPING WAR',
    explainTxt: `A Charity NFT Collection to raise funds for children impacted by the war. Our charity partner UNCHAIN will manage the distribution and tracking of donations to children in need. Read how UNCHAIN distributes aid <a href='https://unchain.fund/about'>here</a>.`,
    countdownTxt: `Initial Mint is now closed.`,
    countdownBtn: 'VIEW ON PARAS',
    explanatoryHeader: `Why We're Doing This`,
    eplanatoryTxt: `Recently, <a href='https://open.spotify.com/artist/4f44GWlEQdXaWl8gQ9sPBC?si=99gcEeMzQTmhGWgtFgSu8g&nd=1' target='_blank'>Wayne Snow</a> commissioned work from <a href='https://koftastudio.com/collections/couture' target='_blank'>Kofta</a>, a leading Design Studio in Kyiv, Ukraine to produce a limited run of designer backpacks made using a unique leather moulding technique. Due to the war, Kofta can no longer operate. Our contact with them is sporadic but they’re alive.

    <br/><br/>Luckily one sample piece was produced before the war started and no more physical editions will be produced again! We believe this backpack symbolises the plight of so many Ukrainians that had to pick up and leave their lives behind, with nothing but a backpack to salvage what they could.
    
    <br/><br/>To support those affected, we are doing a charity auction of this 1-of-1 backpack (retails for €1,500) alongside an open edition collection of NFTs by leading visual artists Mara, The Dons and EV3RETH.
    
    <br/><br/>Our charity partner UNCHAIN will manage the distribution and tracking of donations to children in need.`,
    launchDayHeader: `COLLECTION DROPS<br/>9TH JUNE - 9PM GMT`,
    launchDayMiniHeader: 'Minting open for <u>60hrs only</u>',
    launchDaySmallHeader: '(the average time it takes to escape the warzone)',
    launchDayBtn: 'Tell your frens',
    artistSeriesHeader: 'THE COLLECTION',
    artworkHeader: 'Story behind the artwork',
    artworkBtn: 'PLACE BID',
    teamHeader: 'THE TEAM',
    faqHeader: 'F.A.Q.',
    contactHeader: 'Still have questions?',
    contactSubHeader: 'We are happy to answer all of them',
    contactBtn: 'Send',
    footerCopyright: 'iiNDYVERSE Ltd © 2022. All Rights Reserved.',
    footerTerms: 'Terms and Conditions',
    footerPolicy: 'Privacy Policy'

}